// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__ContactUs__aTmBo","socialMediaInfo":"socialMediaInfo__ContactUs__aTmBo","socialMediaLinks":"socialMediaLinks__ContactUs__aTmBo","icon":"icon__ContactUs__aTmBo"};